/// <reference path="ProdottiDialog.ts" />

namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiClonableDialog extends Gamification.ProdottiDialog {
        protected updateInterface() {

            // by default cloneButton is hidden in base UpdateInterface method
            super.updateInterface();

            // here we show it if it is edit mode (not new)
            this.cloneButton.toggle(this.isEditMode());

            if (Q.Authorization.hasPermission("Role:SuperAdmin")) {
                this.cloneButton.hide();
            }
        }

        /**
         * Overriding this method is optional to customize cloned entity
         */
        protected getCloningEntity() {
            var clone = super.getCloningEntity();

            // add (Clone) suffix if it's not already added
            var suffix = ' [ Clonato ]';
            if (!Q.endsWith(clone.Nome || '', suffix)) {
                clone.Nome = (clone.Nome || '') + suffix;
            }

            // Escusioni
            clone.BadgeList.forEach(row => { row.ImmagineOttenuto = null; row.ImmagineNonOttenuto = null })

            return clone;
        }
    }
}